/* eslint-disable */
import React, { useState, useContext } from 'react';
import { Box, Typography, Divider, Popover } from '@mui/material';
import ConfigContext from 'Shared/ConfigContext';
import AppButton from 'Shared/UI/Button';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import useAddCart from 'hooks/useAddCart';
import AddCartDialog from 'Components/CartPage/V2/AddCartDialog';

const PanierDropDown = ({ open, anchorEl, handleClose }) => {
  const { state: { paniers } } = useContext(ConfigContext);
  const history = useHistory();
  const { showAddDialog, setShowAddDialog, adding, handleAddCart } = useAddCart();

  const availablePaniers = (paniers || []).filter((p) => p.validated === 0);

  const formatDate = (d) => {
    try { return format(new Date(d), 'dd/MM/yyyy', { locale: fr }); }
    catch { return ''; }
  };

  const getTotal = (cart) =>
    cart.totalNetTtc || (cart.products || []).reduce((sum, p) => sum + (p.price || 0) * (p.quantity || 1), 0);

  const formatPrice = (amount) =>
    `${amount.toFixed(2).replace('.', ',')} Dh`;

  const handleCreatePanier = () => {
    handleClose();
    setShowAddDialog(true);
  };

  const handleGererPaniers = () => {
    handleClose();
    history.push('/cart');
  };

  return (
    <>
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '12px',
          width: '400px',
          boxShadow: '0px 10px 40px rgba(0,0,0,0.12)',
          border: '1px solid #E5E7EB',
          mt: '20px',
          ml:'14px'
        },
      }}
    >
      <Box sx={{ p: '20px 20px 16px 20px' }}>

        {/* Title */}
        <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#000000', mb: '16px' }}>
          Mes paniers{' '}
          <Box component="span" sx={{ color: '#000000',ml:'-2px' }}>({availablePaniers.length})</Box>
        </Typography>

        <Divider sx={{ borderColor: '#F1F5F9', borderBottomWidth: '1.5px', mb: '4px' }} />

        {/* Panier list */}
        {availablePaniers.length === 0 ? (
          <Typography sx={{ fontSize: '13px', color: '#A0AEC0', textAlign: 'center', py: '12px' }}>
            Aucun panier en cours
          </Typography>
        ) : (
          availablePaniers.map((p, i) => (
            <Box key={p.name}>
              <Box sx={{ py: '4px' }}>
                {/* Row 1: Name + Price */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#000000' }}>
                    {p.name}
                  </Typography>
                  <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#385576' }}>
                    {formatPrice(getTotal(p))}
                  </Typography>
                </Box>
                {/* Row 2: Date + Articles */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '2px' }}>
                  {p.createdAt && (
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '2px', fontSize: '12px', fontWeight: 600, color: '#717182' }}>
                      <span>Créé le :&nbsp;</span>
                      {formatDate(p.createdAt).split('/').map((part, i, arr) => (
                        <React.Fragment key={i}>
                          <span style={{ lineHeight: 1 }}>{part}</span>
                          {i < arr.length - 1 && <span style={{ fontSize: '9px', lineHeight: 1, display: 'inline-flex', alignItems: 'center', WebkitTextStroke: '0.8px #717182' }}>/</span>}
                        </React.Fragment>
                      ))}
                    </Box>
                  )}
                  <Typography sx={{ fontSize: '12px', color: '#8397AE', fontWeight: 600, ml: 'auto' }}>
                    {(() => { const n = p.nombreProduits ?? (p.products || []).length; return `${n} article${n > 1 ? 's' : ''}`; })()}
                  </Typography>
                </Box>
              </Box>
              {i < availablePaniers.length - 1 && <Divider sx={{ borderColor: '#F1F5F9', borderBottomWidth: '1.5px' }} />}
            </Box>
          ))
        )}

        {/* Buttons */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', mt: '16px' }}>
          <AppButton
            variant="add"
            label="Créer un panier"
            icon={null}
            fullWidth
            onClick={handleCreatePanier}
            sx={{ borderRadius: '8px', boxShadow: '0px 4px 12px rgba(0,123,198,0.25)' }}
          />
          <AppButton
            variant="consult"
            label="Gérer mes paniers"
            icon={null}
            fullWidth
            onClick={handleGererPaniers}
            sx={{ borderRadius: '8px', boxShadow: '0px 4px 12px rgba(0,0,0,0.08)' }}
          />
        </Box>

      </Box>
    </Popover>

    <AddCartDialog
      open={showAddDialog}
      onClose={() => setShowAddDialog(false)}
      onAdd={handleAddCart}
      loading={adding}
    />
    </>
  );
};

export default PanierDropDown;